import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_licenseplate_by_licenseplateIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplateId: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, ShipmentId?: number, ShippingContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, LicensePlateContents?: { LicensePlateId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, MaterialId?: number, VendorLotId?: number } }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplateId)) {
      missingRequiredInParams.push('\'licenseplateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_licenseplate_by_licenseplateId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licenseplateId: number    }) {
        if(isNil(inParams.licenseplateId)) {
          return true; 
        }
      return false;
    }
}
